import { expandElement } from "../utils/helper.ts";
import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass.ts";

class Collapse extends MainClass {
    
    constructor( options: MAIN_CLASS_PARAMS ) {
        super( options );
        this.selector && this.init();
    }
    init () {
	   const toggleCollapseBtn = this.selector.querySelector( '.raise-collapse-toggle' ) as HTMLElement;
	   if (toggleCollapseBtn) {
		const showMoreText = toggleCollapseBtn.getAttribute( 'data-text-more' ) || '';
		const showLessText = toggleCollapseBtn.getAttribute( 'data-text-less' ) || '';
		toggleCollapseBtn.addEventListener( 'click', () => {
			toggleCollapseBtn.classList.toggle( 'opened' );
			expandElement( toggleCollapseBtn, this.selector, showMoreText, showLessText );
		})
	   }
    }
}

export default Collapse;

